import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import Routes from './routes';

import GlobalStyle from './styles/global';
import AlertStyle from './styles/alert';
import AppProvider from './hooks';

const App: React.FC = () => (
  <>
    <Router>
      <GlobalStyle />
      <AlertStyle />

      <AppProvider>
        <Routes />
      </AppProvider>
    </Router>
  </>
);

export default App;
